import React from 'react';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Utils
import { generateHeaderForQuestion } from 'Shared/utils/Reviews.utils';

// Components
import MultilineDescription from '../MultilineDescription/MultilineDescription';

// Styles
import './TitleDescriptionSectionReview.scss';

type Props = {
  question;
};

const TitleDescriptionSectionReview = ({ question }: Props) => {
  const header = generateHeaderForQuestion({ question });
  const description = ReviewFormTemplatesHelpers.getQuestionDescription(question);

  const baseClassName = 'TitleDescriptionSectionReview';
  return (
    <div className={baseClassName}>
      <p className={`${baseClassName}__property`}>{header}</p>
      {description && <MultilineDescription description={description} />}
    </div>
  );
};

export default TitleDescriptionSectionReview;
